<template>
    <div>
        <div>
            <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加年限' }" v-has="'btn_add'"  > 添加
            </a-button>

            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="confirm('')"
                    @cancel="()=>{}"
                    :disabled="!hasSelected"
            >
                <a-button   type="primary" :disabled="!hasSelected" :loading="loading" v-has="'btn_delete'">
                    删除
                </a-button>
            </a-popconfirm>
            <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" style="width: 40%">
          <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visibleForm = true; titleForm='修改年限'; editId=text.id ; }" v-has="'btn_edit'">编辑 <a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <NewForm :visible="visibleForm" :title="titleForm" :editId="editId"
                  @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>

    </div>

</template>

<script>
    import API from "./api";
    import NewForm from "./components/newForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        // {
        //     title: "id",
        //     dataIndex: "id",
        //     ellipsis: true,
        //     key: "id"
        // },
        {
            title: "服务器年限",
            dataIndex: "year",
            ellipsis: true,
            key: "year"
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                selectedRowKeys: [], // Check here to configure the default column
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/Set/ServerAge"; //设置左侧导航2-2 active
        },
        components: {NewForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            getList(page) {
                API.administrator.GET_AROLE(page||1).then(res => {
                    this.data = res.data.data
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.administrator.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            confirm(id) {
                if(id==''){
                    id=this.selectedRowKeys
                }
                removeById(API.administrator.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                        this.selectedRowKeys=[]
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
